
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/var/canvas/ui/shared/groups/jst/_selfSignupHelp.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/manage-groups/jst/groupCategoryDetail';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"group-category-summary__messages\">\n      <div>\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.self_signup_blurb", "Self sign-up is enabled for these groups.", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.self_signup_blurb", "Self sign-up is enabled for these groups.", options)))
    + "\n        ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.self_signup), "restricted", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.self_signup), "restricted", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = self.invokePartial(partials['ui/shared/groups/jst/_selfSignupHelp.handlebars'], 'ui/shared/groups/jst/_selfSignupHelp.handlebars', depth0, helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.group_limit), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <span>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.restricted_self_signup_blurb", "All students in a group are required to be in the same section.", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.restricted_self_signup_blurb", "All students in a group are required to be in the same section.", options)))
    + "</span>\n        ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <div>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'group_limit': ((depth0 && depth0.group_limit)),
    'w0': ("<strong>$1</strong>"),
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.group_limit_blurb", "Groups are limited to *%{group_limit}* members.", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.group_limit_blurb", "Groups are limited to *%{group_limit}* members.", options)))
    + "</div>\n      ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n  <div class=\"group-category-actions\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canAdd), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0['protected']), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n  <div id=\"group-import-modal-mount-point\"></div>\n  <div id=\"group-mount-point\"></div>\n  ";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.context_class_name), "Course", options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.context_class_name), "Course", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <button class=\"btn add-group\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "add_group_c84f9e9d", "Add Group", options) : helperMissing.call(depth0, "t", "add_group_c84f9e9d", "Add Group", options)))
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "add_group_c84f9e9d", "Add Group", options) : helperMissing.call(depth0, "t", "add_group_c84f9e9d", "Add Group", options)))
    + "\"><i class='icon-plus'></i>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.group", "Group", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.group", "Group", options)))
    + "</button>\n    ";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        <button class=\"btn import-groups\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "import_1b31507", "Import", options) : helperMissing.call(depth0, "t", "import_1b31507", "Import", options)))
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "import_1b31507", "Import", options) : helperMissing.call(depth0, "t", "import_1b31507", "Import", options)))
    + "\"><i class='icon-plus'></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.import", "Import", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.import", "Import", options)))
    + "</button>\n      ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <span>\n        <a id=\"group-category-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-actions\" class=\"al-trigger btn\" role=\"button\" aria-haspopup=\"true\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.settings", "Settings", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.settings", "Settings", options)))
    + "\" href=\"#\">\n          <i class=\"icon-more\" aria-hidden=\"true\"></i>\n          <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.category_settings", "Settings", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.category_settings", "Settings", options)))
    + "</span>\n        </a>\n        <ul class=\"al-options\" role=\"menu\" tabindex=\"0\" aria-hidden=\"true\" aria-expanded=\"false\" aria-activedescendant=\"toolbar-2\">\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canMessageMembers), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canAssignMembers), {hash:{},inverse:self.noop,fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.noop,fn:self.program(17, program17, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canDelete), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </ul>\n      </span>\n    ";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n             <li>\n               <a href=\"#\" class=\"icon-email message-all-unassigned\" data-focus-returns-to=\"group-category-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-actions\">\n                 "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.message_all_unassigned_option", "Message All Unassigned Students", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.message_all_unassigned_option", "Message All Unassigned Students", options)))
    + "\n               </a>\n             </li>\n             <div id=\"group-category-message-all-unassigned-mount-point\"></div>\n          ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n            <li>\n              <a href=\"#\" class=\"icon-user randomly-assign-members\" data-focus-returns-to=\"group-category-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-actions\">\n                "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.randomly_assign_students_option", "Randomly Assign Students", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.randomly_assign_students_option", "Randomly Assign Students", options)))
    + "\n              </a>\n            </li>\n          ";
  return buffer;
  }

function program15(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <li>\n            <a href=\"#\" class=\"icon-edit edit-category\" data-focus-returns-to=\"group-category-";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "-actions\" >\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.edit_category_option", "Edit", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.edit_category_option", "Edit", options)))
    + "\n            </a>\n          </li>\n          ";
  return buffer;
  }

function program17(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canManage), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  return buffer;
  }
function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <li>\n            <a href=\"";
  if (helper = helpers.downloadGroupCategoryRosterCSVPath) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.downloadGroupCategoryRosterCSVPath); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"icon-download download-group-category-roster-csv\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "download_group_category_roster_csv_6050a420", "Download Group Category Roster CSV", options) : helperMissing.call(depth0, "t", "download_group_category_roster_csv_6050a420", "Download Group Category Roster CSV", options)))
    + "\n            </a>\n          </li>\n          ";
  return buffer;
  }

function program20(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li>\n            <a href=\"#\" class=\"icon-copy-course clone-category\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "clone_group_set_c2a40e15", "Clone Group Set", options) : helperMissing.call(depth0, "t", "clone_group_set_c2a40e15", "Clone Group Set", options)))
    + "\n            </a>\n          </li>\n          <div id=\"group-category-clone-mount-point\"></div>\n          ";
  return buffer;
  }

function program22(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li>\n            <a href=\"#\" class=\"icon-trash delete-category\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.delete_category_option", "Delete", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.delete_category_option", "Delete", options)))
    + "\n            </a>\n          </li>\n          ";
  return buffer;
  }

function program24(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div class=\"alert\">\n    <i class=\"icon-warning\"></i>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.uncategorized_groups", "These groups are not associated to any particular group set. Because they were imported via SIS, they can only be updated or deleted via SIS.", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.uncategorized_groups", "These groups are not associated to any particular group set. Because they were imported via SIS, they can only be updated or deleted via SIS.", options)))
    + "\n  </div>\n";
  return buffer;
  }

function program26(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div class=\"alert student-organized-groups\"><i class=\"icon-warning\"></i> "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_category_detail")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_category_detail.self_organized_warning", "These groups are self-organized by students. Unlike other types of groups, students can belong to more than one of these groups at a time, so these groups cannot be used for graded assignments.", options) : helperMissing.call(depth0, "t", "groups.manage.group_category_detail.self_organized_warning", "These groups are self-organized by students. Unlike other types of groups, students can belong to more than one of these groups at a time, so these groups cannot be used for graded assignments.", options)))
    + "</div>\n";
  return buffer;
  }

  buffer += "<div class=\"group-category-summary__detailLayout\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.self_signup), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.groupCreationInProgress), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.locked), {hash:{},inverse:self.noop,fn:self.program(24, program24, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.noop,fn:self.program(26, program26, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.role), "student_organized", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.role), "student_organized", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  